var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"not-found"},[_c('h1',{staticClass:"not-found__title"},[_vm._v(_vm._s(_vm.$t('notFound.title')))]),_c('p',{staticClass:"not-found__text"},[_vm._v(_vm._s(_vm.$t('notFound.message')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }